import { useEffect, useContext } from "react";
import Context from "../../../scripts/context/User";
import axios from "axios";
import toast from "react-hot-toast";
import { useOutletContext, useSearchParams } from "react-router-dom";

export default function EmailVerification() {
  const { globalState, setGlobalState } = useContext(Context);
  const { handleNext, loading, setLoading } = useOutletContext();
  let [searchParams] = useSearchParams();

  useEffect(
    () =>
      searchParams.get("message") && toast.error(searchParams.get("message")),
    [searchParams]
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    setGlobalState({
      ...globalState,
      registration_step: 2,
    });
    setLoading(true);

    axios.get("register/email_verification/check").then(({ data }) => {
      setLoading(false);
      if (data.status) {
        handleNext();
      } else {
        toast.error(data.message);
      }
    }).catch(() => {
      setLoading(false);
      toast.error("Something went wrong");
    });
  };

  const handleResend = () => {
    setLoading(true);
    axios
      .post("register/email_verification/sendEmailVerification")
      .then(({ data }) => {
        toast.success(data.message);
        setLoading(false);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        setLoading(false);
      });
  };

  return (
    <form onSubmit={handleSubmit} id="EmailVerification">
      <div className="pb-5">
        <div className="pt-lg-0 pt-5 pb-15">
          <h3 className="font-weight-bolder text-white font-size-h2 font-size-h1-lg">
            Email Verification
          </h3>
          <div className="text-muted font-weight-bold font-size-h4 my-10">
            Please verify your email before proceeding and be sure to check your
            spam folder. If you would like the email to be resent, please click
            the resend button.
          </div>
          <div className="row">
            <div className="col-xl-6">
              <button
                onClick={handleResend}
                disabled={loading}
                className="btn btn-pill btn-primary verify-btn font-weight-bold opacity-90 px-15 py-3"
                tabindex="0"
                type="button"
              >
                Resend Verfication Email
                <span className="MuiTouchRipple-root"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
